import axios from 'axios';
import { API_URL } from './api';

export const licenseService = {
    list () {
        console.log('licenseService: list');

        return axios
            .get(`${API_URL}/licenties`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    get (id) {
        console.log('licenseService: get');

        return axios
            .get(`${API_URL}/licenties/${id}`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    stop (id, formData) {
        console.log('licenseService: stop');

        return axios
            .put(`${API_URL}/licenties/stop/${id}`, formData)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },
};

export default licenseService;
